import type { Sport } from '@painpal/contracts';
import { SPORT_META } from '../lib/sports';
import { SPORT_COLORS } from '../theme/tokens';
import styles from './SportTag.module.css';

export function SportTag({ sport }: { sport: Sport }) {
  const { label, Icon } = SPORT_META[sport];
  return (
    <span className={styles.tag} data-sport={sport} style={{ background: SPORT_COLORS[sport] }}>
      <Icon size={11} aria-hidden="true" />
      {label}
    </span>
  );
}
